import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VideoSources from "../components/VideoSources";
import HowItWorks from "../components/HowItWorks";
import Pricing from "../components/Pricing";
import Footer from "../components/Footer";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { EmbeddedCheckoutModal } from "../components/EmbeddedCheckoutModal";
import { PlanPromoModal } from "../components/PlanPromoModal";

export default function Landing() {
  const { t, lang, L } = useLang();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [checkout, setCheckout] = useState(null);

  const onSelectPlan = async (plan, yearly) => {
    if (plan.id === "trial") {
      navigate("/studio");
      return;
    }
    const lookup_key = `${plan.id}_${yearly ? "yearly" : "monthly"}`;
    const tid = toast.loading(L("Abriendo pago seguro...", "Opening secure checkout..."));
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
        embedded: true,
      });
      toast.dismiss(tid);
      if (data.client_secret && data.publishable_key) setCheckout({ ...data, planName: plan.id.toUpperCase(), plan, yearly });
      else window.location.href = data.checkout_url;
    } catch (e) {
      toast.dismiss(tid);
      toast.error(L("No se pudo iniciar el pago.", "Could not start checkout."));
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      {checkout && <EmbeddedCheckoutModal data={checkout} onClose={() => setCheckout(null)} />}
      <PlanPromoModal onSelectPlan={onSelectPlan} enabled={!user || !user.plan || user.plan === "trial"} />
      <main>
        <Hero />
        <VideoSources />
        <HowItWorks />
        <Pricing onSelectPlan={onSelectPlan} />

        <section className="py-20 sm:py-28">
          <div className="max-w-4xl mx-auto px-5">
            <div className="relative overflow-hidden rounded-3xl border border-yellow-400/30 bg-gradient-to-br from-yellow-400/[0.1] via-zinc-900 to-zinc-900 p-10 sm:p-16 text-center">
              <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-48 w-48 bg-yellow-400/20 blur-3xl rounded-full" />
              <h2 className="relative text-3xl sm:text-5xl font-extrabold tracking-tight">{t("cta_title")}</h2>
              <p className="relative mt-4 text-zinc-300 text-lg">{t("cta_sub")}</p>
              <Button
                onClick={() => navigate("/studio")}
                className="relative mt-8 bg-yellow-400 hover:bg-yellow-300 text-zinc-950 font-bold rounded-xl px-8 py-6 text-base shadow-[0_0_40px_-8px_rgba(250,204,21,0.7)]"
              >
                {t("cta_button")}
                <ArrowRight className="h-4 w-4 ml-1.5" />
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
